import { useTranslation } from 'react-i18next'

const CompanyFormsModalHeader = () => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-y-2">
      <p>{t('forms.create_new_form')}</p>
      <p className="text-secondary-gray text-sm pb-6">{t('forms.fill_info')}</p>
    </div>
  )
}

export default CompanyFormsModalHeader
